<script lang="ts">
    import type {AvailableSize, KpLoaderSettings} from './types';
    import {getLocalization} from 'core/svelte-context/context';

    export let size: AvailableSize;
    export let color: string | null = null;

    const localize = getLocalization();

    const sizeToDimensionMap: Record<AvailableSize, KpLoaderSettings> = {
        xxs: {sizePx: 12, borderWidthPx: 1, animationDuration: 0.6},
        xs: {sizePx: 16, borderWidthPx: 2, animationDuration: 0.7},
        sm: {sizePx: 28, borderWidthPx: 3, animationDuration: 0.8},
        md: {sizePx: 42, borderWidthPx: 3, animationDuration: 0.9},
        lg: {sizePx: 84, borderWidthPx: 4, animationDuration: 1.0}
    }

    const loaderSettings = sizeToDimensionMap[size];
</script>

{#if loaderSettings}
    <span class="loader"
          aria-label="{localize(/* @kp-localization commons.LoadingInProgress */ 'commons.LoadingInProgress')}"
          style="--borderWidth: {loaderSettings.borderWidthPx}px; --borderColor: {color ?? 'var(--accent-blue-new)'}; --size: {loaderSettings.sizePx}px; --animationDuration: {loaderSettings.animationDuration}s"></span>
{/if}

<style lang="less">
    .loader {
        border-radius: 75%;
        display: inline-block;
        box-sizing: border-box;
        border: var(--borderWidth) solid var(--borderColor);
        width: var(--size);
        height: var(--size);
        border-bottom-color: transparent;
        line-height: 0;
        animation: rotation var(--animationDuration) linear infinite;
    }

    @keyframes rotation {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
</style>